import { apiSlice } from '@/redux/api-slice'

export const mediaDetailsApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    recycleMedia: build.mutation({
      query: (mediaCode: number) => ({
        method: 'DELETE',
        url: `media/recycle/${mediaCode}`,
      }),
      invalidatesTags: ['Search'],
    }),
  }),
})

export const { useRecycleMediaMutation } = mediaDetailsApi
